import { ParserFunction } from '../type';

export const descriptionParser: ParserFunction = ({
  name,
  location,
}) => {
  const {
    city,
    state,
  } = location || {
    city: '',
    state: '',
  };
  const hasNoLocation = !city || !state;

  if (hasNoLocation) {
    return `Book pet care services with ${name} and browse past reviews, starting rates, achievements and more with Wag!`;
  }

  return `Book pet care services with ${name} in ${city}, ${state} and browse past reviews, starting rates, achievements and more with Wag!`;
};
